import { FC } from 'react';
import './DateSeparator.scss';

export interface DateSeparatorProps {
    date: Date;
}

export const DateSeparator: FC<DateSeparatorProps> = ({ date }) => {
    const formatDate = (date: Date): string => {
        return date.toLocaleDateString(navigator.language, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    return (
        <div className="date-separator">
            <div className="date-separator__line"></div>
            <div className="date-separator__text">
                {formatDate(date)}
            </div>
            <div className="date-separator__line"></div>
        </div>
    );
};